export default "__VITE_ASSET__C1S413$J__"